<template>
    <div>
        <div class="compatibility__influence-container" v-if="show_categories[0]" v-bind:class="{ 'compatibility__influence-container--no-subcategories': hide_subcategory, 'compatibility__influence-container--condensed': condensed}">
            <div class="compatibility__influence-category">
                <div class="compatibility__strength">{{getStrength(reports.business)}}</div>
                <div class="compatibility__details">
                    <strong v-translate>Business</strong>
                    <div class="progress-bar">
                        <div class="progress-bar__bar" :style="{width: calculateWidth(getStrength(reports.business), percentage_sliders)+'%'}"></div>
                    </div>
                </div>
            </div>
            <div class="compatibility__influence-subcategories" v-if="expand_subcategory_business" key="my-team-report-sub-business">
                <template v-for="(sub_strength, sub_category) in reports.business">
                    <div v-if="sub_strength>0" :key="sub_category" class="compatibility__influence-subcategory">
                        <div class="compatibility__strength">{{sub_strength}}</div>
                        <div class="compatibility__details">
                            <strong>{{compatibility_categories.business[sub_category].name}}</strong>
                            <div class="progress-bar">
                                <div class="progress-bar__bar" :style="{width: calculateWidth(sub_strength, percentage_sliders)+'%'}"></div>
                            </div>
                            <div class="compatibility__description" v-if="description">{{compatibility_categories.business[sub_category].description}}</div>
                            <div class="compatibility__description" v-else-if="team_description">{{compatibility_categories.business[sub_category].team_description}}</div>
                        </div>
                    </div>
                </template>
            </div>
            <button v-if="getStrength(reports.business) && !hide_subcategory" class="compatibility__extend-subcategories" @click="expand_subcategory_business = !expand_subcategory_business"
                        v-bind:class="{ 'compatibility__extend-subcategories--active' : expand_subcategory_business }"></button>
        </div>
        <div class="compatibility__influence-container" v-if="show_categories[1]" v-bind:class="{ 'compatibility__influence-container--no-subcategories': hide_subcategory, 'compatibility__influence-container--condensed': condensed}">
            <div class="compatibility__influence-category">
                <div class="compatibility__strength">{{getStrength(reports.health)}}</div>
                <div class="compatibility__details">
                    <strong v-translate>Health</strong>
                    <div class="progress-bar">
                        <div class="progress-bar__bar" :style="{width: calculateWidth(getStrength(reports.health), percentage_sliders)+'%'}"></div>
                    </div>
                </div>
            </div>
            <div class="compatibility__influence-subcategories" v-if="expand_subcategory_health" key="my-team-report-sub-health">
                <template v-for="(sub_strength, sub_category) in reports.health">
                    <div v-if="sub_strength>0" :key="sub_category" class="compatibility__influence-subcategory">
                        <div class="compatibility__strength">{{sub_strength}}</div>
                        <div class="compatibility__details">
                            <strong>{{compatibility_categories.health[sub_category].name}}</strong>
                            <div class="progress-bar">
                                <div class="progress-bar__bar" :style="{width: calculateWidth(sub_strength, percentage_sliders)+'%'}"></div>
                            </div>
                            <div class="compatibility__description" v-if="description">{{compatibility_categories.health[sub_category].description}}</div>
                            <div class="compatibility__description" v-else-if="team_description">{{compatibility_categories.health[sub_category].team_description}}</div>
                        </div>
                    </div>
                </template>
            </div>
            <button v-if="getStrength(reports.health) && !hide_subcategory" class="compatibility__extend-subcategories" @click="expand_subcategory_health = !expand_subcategory_health"
                        v-bind:class="{ 'compatibility__extend-subcategories--active' : expand_subcategory_health }"></button>
        </div>
        <div class="compatibility__influence-container" v-if="show_categories[2]" v-bind:class="{ 'compatibility__influence-container--no-subcategories': hide_subcategory, 'compatibility__influence-container--condensed': condensed}">
            <div class="compatibility__influence-category">
                <div class="compatibility__strength">{{getStrength(reports.relationship)}}</div>
                <div class="compatibility__details">
                    <strong v-translate>Relationship</strong>
                    <div class="progress-bar">
                        <div class="progress-bar__bar" :style="{width: calculateWidth(getStrength(reports.relationship), percentage_sliders)+'%'}"></div>
                    </div>
                </div>
            </div>
            <div class="compatibility__influence-subcategories" v-if="expand_subcategory_relationship" key="my-team-report-sub-relationship">
                <template v-for="(sub_strength, sub_category) in reports.relationship">
                    <div v-if="sub_strength>0" :key="sub_category" class="compatibility__influence-subcategory">
                        <div class="compatibility__strength">{{sub_strength}}</div>
                        <div class="compatibility__details">
                            <strong>{{compatibility_categories.relationship[sub_category].name}}</strong>
                            <div class="progress-bar">
                                <div class="progress-bar__bar" :style="{width: calculateWidth(sub_strength, percentage_sliders)+'%'}"></div>
                            </div>
                            <div class="compatibility__description" v-if="description">{{compatibility_categories.relationship[sub_category].description}}</div>
                            <div class="compatibility__description" v-else-if="team_description">{{compatibility_categories.relationship[sub_category].team_description}}</div>
                        </div>
                    </div>
                </template>
            </div>
            <button v-if="getStrength(reports.relationship) && !hide_subcategory" class="compatibility__extend-subcategories" @click="expand_subcategory_relationship = !expand_subcategory_relationship"
                        v-bind:class="{ 'compatibility__extend-subcategories--active' : expand_subcategory_relationship }"></button>
        </div>
        <div class="compatibility__influence-container" v-if="show_categories[3]" v-bind:class="{ 'compatibility__influence-container--no-subcategories': hide_subcategory, 'compatibility__influence-container--condensed': condensed}">
            <div class="compatibility__influence-category">
                <div class="compatibility__strength">{{getStrength(reports.personal)}}</div>
                <div class="compatibility__details">
                    <strong v-translate>Personal</strong>
                    <div class="progress-bar">
                        <div class="progress-bar__bar" :style="{width: calculateWidth(getStrength(reports.personal), percentage_sliders)+'%'}"></div>
                    </div>
                </div>
            </div>
            <div class="compatibility__influence-subcategories" v-if="expand_subcategory_personal" key="my-team-report-sub-personal">
                <template v-for="(sub_strength, sub_category) in reports.personal">
                    <div v-if="sub_strength>0" :key="sub_category" class="compatibility__influence-subcategory">
                        <div class="compatibility__strength">{{sub_strength}}</div>
                        <div class="compatibility__details">
                            <strong>{{compatibility_categories.personal[sub_category].name}}</strong>
                            <div class="progress-bar">
                                <div class="progress-bar__bar" :style="{width: calculateWidth(sub_strength, percentage_sliders)+'%'}"></div>
                            </div>
                            <div class="compatibility__description" v-if="description">{{compatibility_categories.personal[sub_category].description}}</div>
                            <div class="compatibility__description" v-else-if="team_description">{{compatibility_categories.personal[sub_category].team_description}}</div>
                        </div>
                    </div>
                </template>
            </div>
            <button v-if="getStrength(reports.personal) && !hide_subcategory" class="compatibility__extend-subcategories" @click="expand_subcategory_personal = !expand_subcategory_personal"
                        v-bind:class="{ 'compatibility__extend-subcategories--active' : expand_subcategory_personal }"></button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'compatibility-sliders',
        props: {
            reports: { type: Object, required: false, },
            compatibility_categories: { type: Object, required: false, },
            hide_subcategory: { type: Boolean, required: false, default: false, },
            condensed: { type: Boolean, required: false, default: false, },
            description: { type: Boolean, required: false, default: false, },
            team_description: { type: Boolean, required: false, default: false, },
            show_categories: { type: Array, required: false, default: function () { return [1,1,1,1] } },
            percentage_sliders: { type: Boolean, required: false, default: false, },
        },
        data() {
            return {
                expand_subcategory_business: false,
                expand_subcategory_health: false,
                expand_subcategory_relationship: false,
                expand_subcategory_personal: false,
            }
        },
        methods: {
            calculateWidth: function (strength, percentage = false) {
                if (percentage) {
                    return strength
                } else {
                    if (strength === 3) {
                        return 100
                    }
                    return strength * 33.3
                }
            },
            getStrength: function(obj) {
                let arr = Object.values(obj);
                return Math.max(...arr);
            },
        }
    }
</script>